angular.module("dx.webapp.lti", [
	"ngRoute",

	"digiexam.exam",
	"digiexam.services",
	"dx.webapp.exam",
	"dx.webapp.library",
	"dx.webapp.navigation",
	"dx.webapp.session",

	"dx.ui.components.dialog",
	"dx.ui.components.localize",
	"dx.ui.dataTypes.grading",
]);
